import type { App } from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { ISentryUserInfo } from '../types'
export function setupSentry(app: App<Element>) {
  //@ts-expect-error
  const env = process.env.NODE_ENV
  if (env !== 'development') {
    Sentry.init({
      environment: env,
      //@ts-expect-error
      integrations: [new VueIntegration({ Vue: app })],
      dsn:
        'https://9cf682e7141746a99d0cc04154e83fc5@o176457.ingest.sentry.io/5637274',
    })
  }
}

export function setSentryUser(meta: ISentryUserInfo) {
  try {
    Sentry.setUser({
      email: meta.email,
      userId: meta.userId,
      location: meta.location,
      userName: meta.userName,
    })
  } catch (error) {
    Sentry.setUser({
      email: meta.email,
      userId: meta.userId,
      location: meta.location,
    })
  }
}
